import { render, staticRenderFns } from "./AddFilter.vue?vue&type=template&id=b511c4ae&scoped=true"
import script from "./AddFilter.vue?vue&type=script&lang=js"
export * from "./AddFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b511c4ae",
  null
  
)

export default component.exports